"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.currentLocaleSettings = exports.currentLocale = void 0;
exports.updateLocale = updateLocale;
const en_GB_1 = __importDefault(require("date-fns/locale/en-GB"));
const en_US_1 = __importDefault(require("date-fns/locale/en-US"));
const de_1 = __importDefault(require("date-fns/locale/de"));
const zh_CN_1 = __importDefault(require("date-fns/locale/zh-CN"));
const it_1 = __importDefault(require("date-fns/locale/it"));
const es_1 = __importDefault(require("date-fns/locale/es"));
const ja_1 = __importDefault(require("date-fns/locale/ja"));
const locales = {
    "en-GB": en_GB_1.default,
    "en-US": en_US_1.default,
    "de-DE": de_1.default,
    "zh-CN": zh_CN_1.default,
};
function closestMatch(locale) {
    if (locale === null || locale === void 0 ? void 0 : locale.startsWith("en-GB")) {
        return en_GB_1.default;
    }
    if (locale === null || locale === void 0 ? void 0 : locale.startsWith("en-US")) {
        return en_US_1.default;
    }
    if (locale === null || locale === void 0 ? void 0 : locale.startsWith("de")) {
        return de_1.default;
    }
    if (locale === null || locale === void 0 ? void 0 : locale.startsWith("zh")) {
        return zh_CN_1.default;
    }
    if (locale === null || locale === void 0 ? void 0 : locale.startsWith("it")) {
        return it_1.default;
    }
    if (locale === null || locale === void 0 ? void 0 : locale.startsWith("es")) {
        return es_1.default;
    }
    if (locale === null || locale === void 0 ? void 0 : locale.startsWith("ja")) {
        return ja_1.default;
    }
    return en_GB_1.default;
}
const localStorageLocale = (_a = localStorage.getItem("i18nextLng")) !== null && _a !== void 0 ? _a : "en-GB";
exports.currentLocale = (_b = locales[localStorageLocale]) !== null && _b !== void 0 ? _b : closestMatch(localStorageLocale);
exports.currentLocaleSettings = { locale: exports.currentLocale };
function updateLocale(locale) {
    try {
        if (locale && locales[locale]) {
            exports.currentLocale = locales[locale];
        }
        else {
            exports.currentLocale = closestMatch(locale);
        }
        exports.currentLocaleSettings = { locale: exports.currentLocale };
        if (exports.currentLocale.code) {
            // Set the HTML element's lang attribute to the language in use
            document.documentElement.lang = exports.currentLocale.code;
        }
    }
    catch (err) {
        console.warn("Error updating locale", err);
    }
}
//# sourceMappingURL=locale.js.map